import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BezugsrechtService } from '@zero/bezugsrecht/domain';
import { DataService } from '@zero/shared/util-web-app-services';
import { environment } from 'environments/environment';
import { filter, skipWhile, switchMap } from 'rxjs';
import { BezugsrechtAnnouncementListItemComponent } from './../announcement-list-item/announcement-list-item.component';

@Component({
  imports: [BezugsrechtAnnouncementListItemComponent, AsyncPipe],
  selector: 'bezugsrecht-announcement-list',
  templateUrl: './announcement-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BezugsrechtAnnouncementListComponent {
  #service = inject(BezugsrechtService);
  #rootDataService = inject(DataService);

  public announcements$ = this.#rootDataService.selectedCustomerChanged.pipe(
    filter(() => environment.isBezugsrechtFeatureActive),
    skipWhile((newCust) => !newCust),
    switchMap((custId) => this.#service.getAnnouncements(custId)),
  );
}
